import { Injectable } from '@angular/core';
import { Activity } from '../activity/activity';
import { Payment } from '../payment/payment';
import { LastRace } from '../adventure/lastrace';
import { CityStatus } from '../status/citystatus';
import { Address } from '../address/address';
  
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable()
export class DashboardService {
	private activitysListUrl;
	private activityAddUrl;
	private activityDeleteUrl;
	private getLastRaceUrl;
	private getCityStatusUrl;
	private addressUrl;
	private addressConfirm;
	private addressMailParam;
	private paymentUrl;
	private codeUrl;

	constructor(private http: HttpClient) {
		
		this.activitysListUrl = 	environment.endpoint + '/runs/list?pageNumber=';
		this.activityAddUrl = 		environment.endpoint + '/runs/add';
		this.activityDeleteUrl = 	environment.endpoint + '/runs/delete';
		this.getLastRaceUrl = 		environment.endpoint + '/adventure/lastrace';
		this.getCityStatusUrl = 	environment.endpoint + '/adventure/status';
		this.addressUrl = 			environment.endpoint + '/address';
		this.addressConfirm = 		environment.endpoint + '/users/confirm';
		this.addressMailParam = 	environment.endpoint + '/users/mailparam';
		this.paymentUrl = 			environment.endpoint + '/payment';
		this.codeUrl = 				environment.endpoint + '/code/use';
	}

	getAddress(): Observable<Address> {
		const httpOptions = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' , 'x-auth-token' : localStorage.getItem("maplerace_auth") })
		};

		return this.http.get<Address>(this.addressUrl, httpOptions).pipe();
	}


	updateAddress(firstname,lastname,address,city,province,postalcode,country): Observable<Address> {
		const httpOptions = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' , 'x-auth-token' : localStorage.getItem("maplerace_auth") })
		};

		var addressUser = new Address();

		addressUser.firstname = firstname;
		addressUser.lastname = lastname;
		addressUser.address = address;
		addressUser.city = city;
		addressUser.province = province;
		addressUser.postalcode = postalcode;
		addressUser.country = country;


		return this.http.post<Address>(this.addressUrl, addressUser, httpOptions).pipe();
	}

	useCode(code): Observable<Address> {
		const httpOptions = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' , 'x-auth-token' : localStorage.getItem("maplerace_auth") })
		};

		var body = {
			"code" : code
		}

		return this.http.post<any>(this.codeUrl, body, httpOptions).pipe();
	}

	getLastRace(): Observable<LastRace> {
		const httpOptions = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' , 'x-auth-token' : localStorage.getItem("maplerace_auth") })
		};

		return this.http.get<LastRace>(this.getLastRaceUrl, httpOptions).pipe();
	}

	getCityStatus(): Observable<CityStatus[]> {
		const httpOptions = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' , 'x-auth-token' : localStorage.getItem("maplerace_auth") })
		};

		return this.http.get<CityStatus[]>(this.getCityStatusUrl, httpOptions).pipe();
	}

	getActivitys(pageNumber : number): Observable<Activity[]> {
		const httpOptions = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' , 'x-auth-token' : localStorage.getItem("maplerace_auth") })
		};


		return this.http.get<Activity[]>(this.activitysListUrl + pageNumber, httpOptions).pipe();
	}
	
	addActivity(distance, duration, dateTime): Observable<Activity> {
		const httpOptions = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' , 'x-auth-token' : localStorage.getItem("maplerace_auth") })
		};

		var activity = new Activity();

		activity.title = "Run";
		activity.distance = distance;
		activity.duration = duration;
		activity.dateTime = dateTime;
		activity.type = "Run";

		return this.http.post<Activity>(this.activityAddUrl, activity, httpOptions).pipe();
	}

	deleteActivity(idRun): Observable<any> {
		const httpOptions = {
			body: {idRun : idRun},
			headers: new HttpHeaders({ 'Content-Type': 'application/json' , 'x-auth-token' : localStorage.getItem("maplerace_auth") })
		};

		let res =  this.http.delete<any>(this.activityDeleteUrl, httpOptions ).pipe();

		return res;
	}

	addPayment(orderId, 
				status, 
				productId,
				payerId?, 
				createTime?,
				payerCountryCode?,
				payerEmailAddress?,
				name?,
				surname?,
				amountValue?,
				currencyCode?): Observable<Payment> {
		const httpOptions = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' , 'x-auth-token' : localStorage.getItem("maplerace_auth") })
		};

		var payment = new Payment();

		payment.orderId = orderId;
		payment.payerId = payerId;
		payment.status = status;
		payment.productId = productId;
		payment.createTime = createTime;
		payment.payerCountryCode = payerCountryCode;
		payment.payerEmailAddress = payerEmailAddress;
		payment.name = name;
		payment.surname = surname;
		payment.amountValue = amountValue;
		payment.currencyCode = currencyCode;


		return this.http.post<Payment>(this.paymentUrl, payment, httpOptions).pipe();
	}
	
	async verifyEmail(id, token){
		let result;

		this.addressConfirm = this.addressConfirm + `?id=${id}&token=${token}`


		await this.http.get(this.addressConfirm).toPromise().then(value=>{
			debugger;
			result = value;
		})

		return result;
	}

	async mailParam(id, token, subscribe){
		let result;

		this.addressMailParam  = this.addressMailParam + `?id=${id}&token=${token}&mail=${subscribe}`;
		await this.http.get(this.addressMailParam).toPromise().then(value => {
			result = value;
		});

		return result;
	}


    
    /* handleError */
	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<T> => {
			console.error(error);
			console.log(`${operation} failed: ${error.message}`);

			return of(result as T);
		};
	}


}